import { Grid } from "@mui/material";
import { ReferenceInput, TextInput, maxLength, required } from "react-admin";
import { dormitoryRequests } from "api/dormitoryApi";
import DormitoryAutocompleteInput from "../Partials/DormitoryAutocompleteInput";

const NUMBER_MAX_LENGTH = 100;

const SaveForm = () => (
  <Grid
    container
    spacing={2}
  >
    <Grid item xs={12} md={6}>
      <ReferenceInput
        source="accommodationId"
        reference={dormitoryRequests.getAccommodationsSelect()}
      >
        <DormitoryAutocompleteInput
          label="Настаняване"
          fullWidth
          validate={[required()]}
        />
      </ReferenceInput>
    </Grid>
    <Grid item xs={12} md={6}>
      <TextInput
        source="number"
        label="Номер на заповед"
        fullWidth
        validate={[required(), maxLength(NUMBER_MAX_LENGTH)]}
      />
    </Grid>
  </Grid>
);

export default SaveForm;
